import { db } from '../lib/postgrest'
import type { ServiceResult } from '../types/productsServices'
import type { StructureEntry } from '../types/structures'

export async function listStructures(schemaName: string): Promise<StructureEntry[]> {
  const { data, error } = await db
    .schema(schemaName)
    .from('d_structures')
    .select('id,name,address')
    .order('name', { ascending: true })

  if (error) throw error
  return (data as StructureEntry[]) ?? []
}

export async function updateStructure(
  schemaName: string,
  id: number,
  input: { name: string; address: string | null },
): Promise<ServiceResult<StructureEntry>> {
  const name = input.name.trim()
  if (!name) return { data: null, error: 'Name is required' }
  const { data, error } = await db
    .schema(schemaName)
    .from('d_structures')
    .update({ name, address: input.address })
    .eq('id', id)
    .select('id,name,address')
    .single()
  if (error) return { data: null, error: error.message }
  return { data: data as StructureEntry, error: null }
}
